import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./layouts/admin/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Program from "./pages/Program";
import ProgramAdd from "./pages/ProgramAction";
import ProgramBasicsEdit from "./pages/ProgramEdit";
import { ToastContainer } from "react-toastify";
import { ProtectedRoute } from "./components/ProtectedRoute";
import DefaultLayouts from "./layouts/frontend/Layout";
import Home from "./pages/frontend/Home";
import ProgramDetail from "./pages/frontend/ProgramDetail";
import Register from "./pages/frontend/Register"; 
import Payment from "./strip/Payment";
import UserLayout from "./layouts/frontend/UserLayout";
import Bookings from "./pages/frontend/Bookings";
import Profile from "./pages/frontend/Profile";
import ThankYou from "./pages/frontend/ThankYou";
import ProgramsList from "./pages/frontend/Programs";
import { BookingList } from "./store/BookingSlice";
import AllBookings from "./pages/BookingList";
import PatientsView from "./components/List/patientsList";
import PatientsList from "./pages/PatientList";
import BookingsDetails from "./pages/frontend/BookingDetails";
import Contact from "./pages/frontend/Contact";

function App() {
  return (
    <BrowserRouter>   
      <Routes>
        <Route path="/admin/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/thankyou" element={<ProtectedRoute>{<ThankYou />}</ProtectedRoute>} />
        <Route path="/" element={<DefaultLayouts />}>
          <Route path="/" element={<Home />} />         
          <Route path="/program/:programSlug" element={<ProgramDetail />} />
          <Route path="/programs/" element={<ProgramsList />} />
          <Route path="/contact/" element={<Contact />} />
          <Route path="/checkout" element={<ProtectedRoute>{<Payment />}</ProtectedRoute>} />    
        </Route>  
        <Route path="/" element={<UserLayout />}>
          <Route path="/bookings" element={<ProtectedRoute>{<Bookings />}</ProtectedRoute>} />  
          <Route path="/booking/:bookingId" element={<ProtectedRoute>{<BookingsDetails />}</ProtectedRoute>} />  
          <Route path="/profile" element={<ProtectedRoute>{<Profile />}</ProtectedRoute>} />  
            
        </Route>
        <Route path="/" element={<Layout />}>
          <Route
            path="admin/dashboard"
            element={<ProtectedRoute>{<Dashboard />}</ProtectedRoute>}
          />
          <Route
            path="admin/programs"
            element={<ProtectedRoute>{<Program />}</ProtectedRoute>}
          />
           <Route
            path="admin/bookings"
            element={<ProtectedRoute>{<AllBookings />}</ProtectedRoute>}
          />  
           <Route
            path="admin/patients"
            element={<ProtectedRoute>{<PatientsList />}</ProtectedRoute>}
          />  
          <Route
            path="admin/programs/add"
            element={<ProtectedRoute>{<ProgramAdd />}</ProtectedRoute>}
          />
          <Route
            path="admin/programs/edit/:id"
            element={<ProtectedRoute>{<ProgramBasicsEdit />}</ProtectedRoute>}
          />
        </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
